import { lazy } from 'react';
import Loadable from 'components/Loadable';

const OAuthConsent = Loadable(lazy(() => import('pages/oauth/OAuthConsent')));

// ===========|| MCP OAUTH CONSENT (NO OTM AUTH — Stytch handles login) ||=========== //

const OAuthRoutes = {
  path: '/oauth/authorize',
  element: <OAuthConsent />
};

export default OAuthRoutes;
